import React from 'react';
import { Loader } from '../../components/loader/Loader';
import { useAssetClass } from '../../contexts/assetClass';
import { TaskServiceDeskUpdate } from './ServiceDesk/Update/TaskServiceDeskUpdate';
import TasksEdit from './TasksEdit';

export const TasksEditRedirect = () => {
  const { assetGuiVersion } = useAssetClass();

  if (assetGuiVersion === undefined) return <Loader />;
  if (assetGuiVersion === 0) return <TasksEdit />;
  if (assetGuiVersion === 1) return <TaskServiceDeskUpdate />;
};
